var React = require('react');

function NextIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.17907 10.8201C0.937794 11.0732 0.546055 11.0572 0.32374 10.785L0.144269 10.5654C-0.0567317 10.3193 -0.0465598 9.95009 0.16764 9.71702L4.04334 5.5L0.16764 1.28298C-0.0465593 1.04991 -0.0567317 0.680683 0.144269 0.434643L0.32374 0.214956C0.546055 -0.0571728 0.937795 -0.0732145 1.17907 0.179932L5.82482 5.05429C6.05839 5.29936 6.05839 5.70064 5.82482 5.94571L1.17907 10.8201Z","fill":"#A5A9AF"}));
}

NextIconInline.defaultProps = {"width":"6","height":"11","viewBox":"0 0 6 11","fill":"none"};

module.exports = NextIconInline;

NextIconInline.default = NextIconInline;
